import { Icon } from '@/components/ui/base/icon/icon'
import { apiCall } from '@api/resources/apiCall'
import { useParams } from 'react-router-dom'
import { PROJECT } from '@modules/missions/keaz/const'
import { ProgressIndicator } from '@smwb/summer-ui'
import style from './taskReportButton.module.less'
import { AgentumReportWithRelations } from '@api/generated'
import { BaseReportFields } from '@modules/missions/keaz/types'
import { useMutationSnackbar } from '@hooks/useMutationSnackbar'

interface TaskReportButtonProps {
  task: AgentumReportWithRelations
}

export function TaskReportButton({ task }: TaskReportButtonProps) {
  const { missionId } = useParams()

  const [taskReport, { isLoading: isTaskReportLoading }] = useMutationSnackbar(
    apiCall.useKeazReportsControllerTaskMutation,
    (taskReportData) => {
      window.open(taskReportData.url, '_blank')
    },
    () => 'Ошибка построения отчета по шагам'
  )

  const [deviationsReport, { isLoading: isDeviationsReportLoading }] = useMutationSnackbar(
    apiCall.useKeazReportsControllerTaskDeviationsMutation,
    (deviationsReportData) => {
      window.open(deviationsReportData.url, '_blank')
    },
    () => 'Ошибка построения отчета по отклонениям'
  )

  if (isTaskReportLoading || isDeviationsReportLoading) {
    return <ProgressIndicator type='indeterminate' variant='circular' className={style.loader} />
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        void taskReport([missionId || '', PROJECT, task[BaseReportFields.origin] as string])
        void deviationsReport([missionId || '', PROJECT, task[BaseReportFields.origin] as string])
      }}
    >
      <Icon icon='download' className={style.icon} />
    </div>
  )
}
